import Model from '@/models/Model';

export default class Sla extends Model {
    get route () {
        return 'slas';
    }

    static get className () {
        return 'Sla';
    }

    static get isInStore () {
        return true;
    }
}
